import { useState } from "react";
import { faqs } from "@/mocks/hotData";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState(0);

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="faq" className="scroll-mt-24 bg-background-100/70 py-16 md:py-20">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
            <i className="ri-question-answer-line"></i>
            常见问题
          </span>
          <h2 className="mt-4 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            吃瓜前，先看这几点
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            关于更新频率、热度算法、投稿与内容原则的疑问，都能在这里找到答案。仍有不清楚的地方，欢迎通过页面底部联系方式与我们沟通。
          </p>
          <div className="mt-6 hidden flex-wrap gap-2 lg:flex">
            {["更新频率", "热度算法", "如何投稿", "客观性"].map((t) => (
              <span key={t} className="rounded-full border border-background-300 bg-background-50 px-3 py-1.5 text-xs text-foreground-600">
                {t}
              </span>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-3 lg:col-span-8">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  open ? "border-primary-300 bg-background-50" : "border-background-200 bg-background-50 hover:border-primary-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className="flex w-full items-center gap-4 px-5 py-4 text-left"
                >
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-sm font-black ${
                      open ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-800"
                    }`}
                  >
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="flex-1 text-sm font-semibold text-foreground-950 md:text-base">{f.q}</span>
                  <i
                    className={`shrink-0 text-lg transition-transform ${open ? "ri-subtract-line text-primary-600" : "ri-add-line text-foreground-400"}`}
                  ></i>
                </button>
                <div className={`grid transition-all duration-300 ${open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600" style={{ paddingLeft: "5.5rem" }}>
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}